export default __webpack_public_path__ + "static/realWorldImg2-1776339a60eccf24413f9c353774dc57.webp";